/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import * as React from 'react';


import Modal from "../../../Modal";
import { DivPrincipal } from './style';
import Button from '../../../Button';
import { useAuth } from '../../../../hooks/auth';
import api from '../../../../services/api';

interface ModalLGPDProps {
  show: boolean;
  title: string;
  handleClose(hasClosed?: boolean): void;
}

const ModalLGPD: React.FC<ModalLGPDProps> = ({ show, title, handleClose }) => {

	const { signOut } = useAuth();

	return (
		<DivPrincipal>
			{show && (
        <Modal
          title={title}
          handleClose={() => handleClose(false)}
          show={show}
          isCloseOff
          style={{ height: "auto", width: "auto" }}
        >
          <div>
            <p style={{ fontSize: 18, fontWeight: 'normal' }}>
							Este é um canal <strong>EXCLUSIVO</strong> para tratamento de Privacidade e Proteção de Dados.
            </p>
            <p style={{ fontSize: 18, fontWeight: 'normal' }}>Seu contato é referente à Privacidade e Proteção de Dados?</p>
          </div>
          <div className='Buttons'>

            <p className='Button'>
              <a
                href="https://landing.privacypoint.com.br/?clid=03b9d6c381582ecaabd26bfde90a0f8f"
                target="_blank"
                rel="noreferrer"
                style={{ color: "white" }}
                onClick={() => handleClose(false)}
              >
                Sim
              </a>
            </p>
            <p className='Button' style={{ color: "white" }} onClick={() => handleClose(true)}>Não</p>
          </div>
        </Modal>
      )}
		</DivPrincipal>
	)
}

export { ModalLGPD };
